// extracted by mini-css-extract-plugin
export default {"loading":"paginated_gantt_chart___loading___e3fdf005"};